import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useTheme } from "styled-components";
import { getToneTokens } from "../../../styles/shared";
import { EmptyHint, ZONE_TONES } from "./styles";

const ChartHeight = 220;

export default function PulmaoHistogram({ pulmaoHist }) {
  const theme = useTheme();
  const total = (pulmaoHist || []).reduce((sum, b) => sum + b.count, 0);

  if (!total) {
    return (
      <EmptyHint>
        Sem ambientes em produção com aprovação e contrato preenchidos.
      </EmptyHint>
    );
  }

  return (
    <div style={{ width: "100%", height: ChartHeight }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={pulmaoHist} margin={{ top: 8, right: 12, bottom: 12, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.border} vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fill: theme.textSecondary, fontSize: 11 }}
            tickLine={false}
            axisLine={{ stroke: theme.border }}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fill: theme.textSecondary, fontSize: 11 }}
            tickLine={false}
            axisLine={{ stroke: theme.border }}
          />
          <Tooltip
            contentStyle={{
              background: theme.surface,
              border: `1px solid ${theme.border}`,
              fontSize: 12,
              borderRadius: 8,
            }}
            formatter={(value) => [`${value} ambiente(s)`, "Quantidade"]}
            labelFormatter={(label) => `Faixa ${label}`}
          />
          <Bar dataKey="count" isAnimationActive={false} radius={[6, 6, 0, 0]}>
            {pulmaoHist.map((entry, index) => (
              <Cell
                key={`bar-${index}`}
                fill={getToneTokens(theme, ZONE_TONES[entry.zona] || "default").text}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
